import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import Webcam from 'react-webcam';
import {camera} from 'react-icons-kit/icomoon/camera';
import SvgIcon from 'react-icons-kit';
import swal from 'sweetalert';

class ModalPhoto extends Component{
	constructor(props, context) {
		super(props, context);
		this.saveImage = this.saveImage.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.capture = this.capture.bind(this);
		this.state = {
		    show: false,
		    image:""
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	saveImage(){
		if(this.state.image.length > 0){
			this.setState({ show: false});
			this.props.save(this.state.image);
		}else{
			swal('Error', 'No ha capturado ninguna fotografía','error');
		}
	}

	handleShow() {
		this.setState({ show: true,image:"" });
	}

	setRef = (webcam) => {
	    this.webcam = webcam;
	}

  	capture() {
	    const imageSrc = this.webcam.getScreenshot();
	    if(imageSrc !== null){
	    	this.setState({image:imageSrc});
		}else{
			swal('Error', 'Imagen no capturada','error');
		}
	};

	render(){
		const { t } = this.props;
		return(
			<Modal show={this.state.show} onHide={this.handleClose} bsSize="large">
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_photo.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{textAlign:"center"}}>
		        		<div className="col-xs-12 col-md-6">
			        		<h4 style={{float:"left",paddingLeft:"30px",textDecoration: "underline"}}>Vista Previa</h4>
					        <Webcam
					          audio={false}
					          height={250}
					          width={250}
					          ref={this.setRef}
					          screenshotFormat="image/jpeg"
					          style={{width:'100%'}}
					        />
					        <button onClick={this.capture}>
					        	<SvgIcon size={20} icon={camera}/>
					        </button>
				        </div>
				        {this.state.image !== ""?
				        	<div className="col-xs-12 col-md-6">
					        	<div className="col-xs-12">
						        <h4 style={{float:"left",paddingLeft:"30px",textDecoration: "underline"}}>Imagen</h4>
						        </div>
						        <img alt="" src={this.state.image} style={{width:"300px",height:"250px"}}/>
					    	</div>
					    :null}
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} keyboardFocused={true} onClick={this.saveImage}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalPhoto) 